module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "speakers"
  }, [_c('div', {
    staticClass: "speakers__speakers"
  }, _vm._l((_vm.currentSpeakers), function(speaker) {
    return _c('div', {
      staticClass: "speakers__speaker"
    }, [_c('div', {
      staticClass: "speaker-card",
      class: {
        'speaker-card--dark': _vm.theme == 'dark'
      },
      on: {
        "click": function($event) {
          _vm.setSpeaker(speaker)
        }
      }
    }, [(speaker.webPhoto) ? _c('div', {
      staticClass: "speaker-card__cover",
      style: ({
        backgroundImage: 'url(' + speaker.webPhoto + ')'
      })
    }) : _c('div', {
      staticClass: "speaker-card__cover"
    }), _vm._v(" "), _c('div', {
      staticClass: "speaker-card__name"
    }, [_vm._v("\n                    " + _vm._s(speaker.name) + "\n                ")])])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8d89132e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/js/components/Speakers.vue
// module id = 76
// module chunks = 1